import React from "react"
import Highscore from "./Highscore"

export default function Scene(props) {

    const [currentScene, setScene] = React.useState() 
    let display = {} 

    const BackButton = () => <button className="floating" onClick={() => setScene("intro")}>Back</button> 
    const Footer = () => <footer><p>Made by Tomasz Goljat. Visit my <a href="https://minidev.pl">portfolio</a>.</p></footer>


    
    switch (currentScene) {
        default: 
        case "intro":
            display = (
                <div className="intro">
                    <h1>Memory Game</h1>
                    <button onClick={() => props.setInGame(true)}>New Game</button>
                    <button onClick={() => setScene("highscore")}>High Score</button>
                    <button onClick={() => setScene("about")}>About</button>
                </div>
            )
            break
        case "highscore":
            display = (
                <div className="highscore">
                   <Highscore /> 
                   <BackButton />
                </div>
            )
            break;
        case "about":
            display = (
                <div className="about">
                    <h1>About</h1>
                    <p>It's just simple memory game.</p>
                    <p>Remember to check out my portfolio!</p>
                    <p>Enjoy!</p>
                    {<BackButton />}
                </div>
            )
            break;
    }
    return <>
    {display}
    <Footer />    
    </>
}